export default __webpack_public_path__ + "static/long_y_cart-9778fa8c3d83022974f185591fcabebc.svg";